import { Constants } from "@lib/titan2/dist/api/common/controller/net/constant/Constants";
import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * PurchaseEntryParams.ts
 */
export class PurchaseEntryParams {
    constructor(currency, ticketId, stakeAmount, messageAcknowledged, roomName, freeRoundsUUID) {
        this.currency = currency;
        this.ticketId = ticketId;
        this.stakeAmount = stakeAmount;
        this.messageAcknowledged = messageAcknowledged;
        this.roomName = roomName;
        this.freeRoundsUUID = freeRoundsUUID;
    }
    liquify() {
        let data = new DataObject();
        data.putNumber(SlingoConstants.PROPERTY_TICKET_ID, this.ticketId);
        data.putString(SlingoConstants.PROPERTY_CURRENCY, this.currency);
        data.putNumber(SlingoConstants.PROPERTY_STAKE_AMOUNT, this.stakeAmount);
        data.putString(SlingoConstants.PROPERTY_ROOM_NAME, this.roomName);
        data.putBoolean(SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED, this.messageAcknowledged);
        if (this.freeRoundsUUID && this.freeRoundsUUID != "") {
            data.putString(Constants.PROPERTY_FREEROUNDS_UUID, this.freeRoundsUUID);
        }
        return data;
    }
}
//# sourceMappingURL=PurchaseEntryParams.js.map